import type { BulkTask } from '../../../api/types';
import type { Dictionary } from '../../../i18n/en';
import type { Reason } from './rules';

/** The task's card title (the send card reuses `sales.issueSend`, RB4-07). */
export function taskTitle(t: Dictionary, task: BulkTask): string {
  if (task === 'send') return t.sales.issueSend;
  return task === 'pdf' ? t.batch.tasks.pdf : t.batch.tasks.discard;
}

/** The run button, named by the task, never with a number (AC-B5). */
export function runLabel(t: Dictionary, task: BulkTask): string {
  return t.batch.run[task];
}

/** The words of a reason (our `batch.reasons.*`, or the single action's `errors.codes.*`). */
export function reasonText(t: Dictionary, reason: Reason): string {
  if ('reason' in reason) return t.batch.reasons[reason.reason];
  return (
    (t.errors.codes as Record<string, string | undefined>)[reason.errorCode] ??
    t.batch.reasons.ourSide
  );
}
